import Vue from 'vue';

Vue.component('black-background-color-inverter', {
    props: {},

    data() {
        return {
            showMenu: false,
        };
    },

    async mounted() {
        this.invertNavigationColor(this.showMenu);
        this.invertFooterColor();
    },

    destroyed() {},

    watch: {
        '$root.showMenu': function (value) {
            this.showMenu = value;
            this.invertNavigationColor(value);
        },
        '$root.showCountries': function (value) {
            this.showMenu = value;
            if (this.$root.showMenu) return;
            this.invertNavigationColor(value);
        },
    },

    methods: {
        invertFooterColor() {
            this.changeFooterContainerColor();
            this.changeFooterLogoColor();
            this.changeFooterItemsColor();
            this.changeFooterDisclaimerColor();
            this.changeFooterDisclaimerPadding();
            this.changeFooterSliderColor();
            this.changeEnergyLabelsColor();
            this.changeSwedenLoanDisclaimerColor();
            this.changeFinancingSectionDesktopTableColor();
            this.changeFinancingSectionMobileAccordionColor();
            this.changeFrFooterPillarsColor();
        },

        invertNavigationColor(isMenuOpen) {
            this.changeNavigationContainerColor(isMenuOpen);
            this.changeNavigationItemsColor(isMenuOpen);
            this.changeLogoColor(isMenuOpen);
            this.changeHamburgerMenuColor(isMenuOpen);
        },

        changeNavigationContainerColor(isMenuOpen) {
            const container = document.querySelector('.header-container');
            container.style.backgroundColor = isMenuOpen ? '#f7f7f7' : 'black';
            container.style.paddingBottom = '2px';

            const navigationDropdowns = document.querySelectorAll(
                '.main-navigation-new-children ',
            );
            const navigationDropdownArrows = document.querySelectorAll(
                '.main-navigation-new__arrow-down',
            );

            const navigationDropdownItemLabels = document.querySelectorAll(
                '.main-navigation-new__label-item',
            );

            if (navigationDropdowns) {
                navigationDropdowns.forEach((dropdown) => {
                    if (isMenuOpen && dropdown.classList.contains('--black')) {
                        dropdown.classList.remove('--black');
                    } else {
                        dropdown.classList.add('--black');
                    }
                });
            }
            if (navigationDropdownArrows) {
                navigationDropdownArrows.forEach((arrow) => {
                    arrow.style.borderColor = isMenuOpen ? 'black' : 'white';
                    arrow.style.opacity = '1';
                });
            }
            if (navigationDropdownItemLabels) {
                navigationDropdownItemLabels.forEach((label) => {
                    label.style.background = isMenuOpen ? 'black' : 'white';
                    label.style.color = isMenuOpen ? 'white' : 'black';
                });
            }
        },

        changeNavigationItemsColor(isMenuOpen) {
            const containerItemParent = document.querySelectorAll(
                '.main-navigation-new__item-children',
            );
            const allContainerItems = document.querySelectorAll(
                '.main-navigation-new__item',
            );
            const allLinkItems = document.querySelectorAll(
                '.main-navigation-new__item-link',
            );
            const countryButton = document.querySelectorAll(
                '.header__country-selector',
            );
            const mapPinIcon = document.querySelector('#map-black-pin-icon');

            const logoText = document.querySelector('.sr-only.bg-black');
            if (logoText) {
                logoText.style.color = isMenuOpen ? 'black' : 'white';
            }

            containerItemParent.forEach((item) => {
                isMenuOpen
                    ? item.classList.remove(
                          'main-navigation-new__item-children--black',
                      )
                    : item.classList.add(
                          'main-navigation-new__item-children--black',
                      );
            });

            allContainerItems.forEach((item) => {
                item.style.setProperty(
                    '--bg-color',
                    isMenuOpen ? 'black' : 'white',
                );
            });
            allLinkItems.forEach((item) => {
                item.style.color = isMenuOpen ? 'black' : 'white';
                item.style.backgroundColor = isMenuOpen
                    ? 'transparent'
                    : 'black';
            });
            const navSeparators = document.querySelectorAll(
                '.main-navigation-new__list > li:last-child',
            );
            navSeparators.forEach((item) => {
                isMenuOpen
                    ? item.style.removeProperty('--separator-color')
                    : item.style.setProperty(
                          '--separator-color',
                          'rgba(255, 255, 255, 0.3)',
                      );
            });
            countryButton.forEach((item) => {
                item.style.color = isMenuOpen ? 'black' : 'white';
            });
            if (mapPinIcon) {
                mapPinIcon.classList = isMenuOpen
                    ? 'map-pin-icon--black'
                    : 'map-pin-icon--white';
            }

            const italyModelNavLinks = document.querySelectorAll(
                '.header__action-link p',
            );

            if (italyModelNavLinks.length) {
                italyModelNavLinks.forEach((link) => {
                    link.style.color = isMenuOpen ? 'black' : 'white';
                });
            }

            const italyNavLinkIcons = document.querySelectorAll(
                '.header__action-links__icon',
            );

            if (italyNavLinkIcons.length) {
                italyNavLinkIcons.forEach((icon) => {
                    icon.classList.remove(
                        'header__action-links__icon--white',
                        'header__action-links__icon--black',
                    );
                    icon.classList.add(
                        isMenuOpen
                            ? 'header__action-links__icon--black'
                            : 'header__action-links__icon--white',
                    );
                });
            }

            const mgMoiIcon = document.querySelector('.header__mg-moi-icon');
            if (mgMoiIcon) {
                mgMoiIcon.classList.remove(
                    'header__mg-moi-icon--white',
                    'header__mg-moi-icon--black',
                );
                mgMoiIcon.classList.add(
                    isMenuOpen
                        ? 'header__mg-moi-icon--black'
                        : 'header__mg-moi-icon--white',
                );
            }

            const mgMoiLink = document.querySelector('.header__mg-moi-title');
            if (mgMoiLink) {
                mgMoiLink.style.color = isMenuOpen ? 'black' : 'white';
            }
        },

        changeLogoColor(isMenuOpen) {
            const allLogos = document.querySelectorAll('#logo-icon--black');
            const globe = document.querySelector('#logo-icon-globe');

            if (allLogos) {
                allLogos.forEach((logo) => {
                    isMenuOpen
                        ? logo.classList.remove('logo-icon--white')
                        : logo.classList.add('logo-icon--white');
                });
            }

            if (globe) {
                isMenuOpen
                    ? globe.classList.remove('globe-icon--white')
                    : globe.classList.add('globe-icon--white');
            }
        },

        changeFooterLogoColor() {
            const footer = document.querySelector('#footer-v2');
            if (!footer) return;

            // Swaps the footer wordmark from the black (light) to the white
            // (dark) variant. The header logo is handled by changeLogoColor.
            footer.classList.add('footer-logo-inverted');
        },

        changeHamburgerMenuColor(isMenuOpen) {
            const allItems = document.querySelectorAll('.hamburger__line');
            allItems.forEach((item) => {
                item.style.backgroundColor = isMenuOpen ? 'black' : 'white';
            });
        },

        changeFooterContainerColor() {
            const container = document.querySelector('#footer-v2');
            container.style.backgroundColor = 'black';
        },

        changeFinancingSectionDesktopTableColor() {
            const financingSectionTableDesktop = document.querySelector(
                '.footer-financing-section__table',
            );
            if (!financingSectionTableDesktop) return;

            const header = financingSectionTableDesktop.querySelector(
                '.footer-financing-section__table__header',
            );
            if (!header) return;

            header.style.backgroundColor = '#2E2E38';
            const headerCells = header.querySelectorAll(
                '.footer-financing-section__table__header__item',
            );
            headerCells.forEach((cell) => {
                cell.style.color = '#C7C7D1';
            });

            const rows = financingSectionTableDesktop.querySelectorAll(
                '.footer-financing-section__table__row',
            );
            rows.forEach((row, index) => {
                row.style.backgroundColor =
                    index % 2 === 0 ? '#000' : '#2E2E38';
                const cells = row.querySelectorAll(
                    '.footer-financing-section__table__body__item',
                );
                cells.forEach((cell) => {
                    cell.style.color = '#C7C7D1';
                });
            });
        },

        changeFinancingSectionMobileAccordionColor() {
            const financingSectionAccordionMobile = document.querySelector(
                '.footer-financing-section__accordion',
            );
            if (!financingSectionAccordionMobile) return;
            const title = financingSectionAccordionMobile.querySelector(
                '.footer-financing-section__accordion__title',
            );

            if (!title) return;
            title.style.color = '#FCFCFD';
            title.style.backgroundColor = '#2E2E38';

            const buttons = financingSectionAccordionMobile.querySelectorAll(
                '.footer-financing-section__accordion__item__header',
            );
            buttons.forEach((button) => {
                button.style.color = '#FCFCFD';
                button.style.backgroundColor = '#000';
                button.style.borderColor = '#505062';
            });

            const bodies = financingSectionAccordionMobile.querySelectorAll(
                '.footer-financing-section__accordion__item__row',
            );
            bodies.forEach((body, index) => {
                body.style.backgroundColor =
                    index % 2 === 0 ? '#000' : '#2E2E38';
                const label = body.querySelector(
                    '.footer-financing-section__accordion__item__label',
                );
                const value = body.querySelector(
                    '.footer-financing-section__accordion__item__value',
                );
                if (label) label.style.color = '#F1F1F4';
                if (value) value.style.color = '#F1F1F4';
            });
        },

        changeSwedenLoanDisclaimerColor() {
            const container = document.getElementById('footer-loan-disclaimer');
            if (!container) return;

            const textContainer = container.querySelector(
                '.footer-loan-disclaimer__text',
            );
            if (!textContainer) return;

            const h3Element = textContainer.querySelector('h3');
            const pElement = textContainer.querySelector('p');
            if (h3Element) h3Element.style.color = 'white';
            if (pElement) pElement.style.color = '#ffffff90';
        },

        changeFooterItemsColor() {
            const allItems = document.querySelectorAll('.footer-link');
            allItems.forEach((item) => {
                item.style.color = 'white';
                item.style.setProperty('--bg-color', 'white');
            });

            const allTitleItems = document.querySelectorAll(
                '.footer-navigation-group__title',
            );
            allTitleItems.forEach((item) => {
                item.style.color = '#aeaeae';
            });
        },

        changeFooterDisclaimerColor() {
            const disclaimers = document.querySelectorAll('#footer-disclaimer');
            if (!disclaimers) return;

            disclaimers.forEach((disclaimer) => {
                disclaimer.style.color = 'white';
            });
        },

        changeFooterDisclaimerPadding() {
            const disclaimer = document.querySelector('.footer-disclaimer');
            if (!disclaimer) return;

            disclaimer.style.paddingBottom = '100px';
        },

        changeFooterSliderColor() {
            const slider = document.querySelector('.footer-slider');
            if (slider) slider.style.color = 'white';
        },

        changeEnergyLabelsColor() {
            const energyLabels = document.getElementById('energy-labels');
            if (energyLabels) energyLabels.classList.add('black');
        },

        changeFrFooterPillarsColor() {
            const pillarsSection = document.querySelector('.fr-footer-pillars');
            if (!pillarsSection) return;

            pillarsSection.classList.add('fr-footer-pillars--dark');
        },
    },
});
